"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnixTimeSchema = exports.TimeSchema = exports.DateSchema = exports.DateTimeSchema = exports.DurationSchema = void 0;
const schema_1 = require("../schema");
const schema_type_1 = require("../schema-type");
class DurationSchema extends schema_1.PrimitiveSchema {
    constructor(name, description, objectInitializer) {
        super(name, description, schema_type_1.SchemaType.Duration);
        this.apply(objectInitializer);
    }
}
exports.DurationSchema = DurationSchema;
class DateTimeSchema extends schema_1.PrimitiveSchema {
    constructor(name, description, objectInitializer) {
        super(name, description, schema_type_1.SchemaType.DateTime);
        this.apply(objectInitializer);
    }
}
exports.DateTimeSchema = DateTimeSchema;
class DateSchema extends schema_1.PrimitiveSchema {
    constructor(name, description, objectInitializer) {
        super(name, description, schema_type_1.SchemaType.Date);
        this.apply(objectInitializer);
    }
}
exports.DateSchema = DateSchema;
class TimeSchema extends schema_1.PrimitiveSchema {
    constructor(name, description, objectInitializer) {
        super(name, description, schema_type_1.SchemaType.Time);
        this.apply(objectInitializer);
    }
}
exports.TimeSchema = TimeSchema;
class UnixTimeSchema extends schema_1.PrimitiveSchema {
    constructor(name, description, objectInitializer) {
        super(name, description, schema_type_1.SchemaType.UnixTime);
        this.apply(objectInitializer);
    }
}
exports.UnixTimeSchema = UnixTimeSchema;
//# sourceMappingURL=time.js.map